<template>
  <div class="ml-4 d-inline-flex align-items-center">
    {{ discountLabel }}
    <input 
      class="mr-2" 
      @change="activeDiscount" 
      type="checkbox"
      v-model="activeDiscountForUser" 
      style="height: 20px; width: 20px;"
    >
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DiscountToggle',
  props: ['admin', 'discountLabel', 'url', 'for'],
  emits: ['discount-changed'],
  data() {
    return {
      activeDiscountForUser: 0
    }
  },
  beforeMount() {
    if (this.admin) {
      this.activeDiscountForUser = this.admin[this.for] == 1
    }
  },
  methods: {
    activeDiscount() {
      axios.post(this.url, { 
            for: this.for,
            active_discount_for_user: this.activeDiscountForUser 
        }, { 
            headers: { 
                "X-CSRFToken": window.csrf_token,
                "Content-Type": "application/json"
            } 
        })
        .then(response => {
          // Emit event to parent component after successful API call
          this.$emit('discount-changed', this.activeDiscountForUser);
        })
        .catch(error => {
          console.error('Error updating discount:', error);
          // Optionally revert the checkbox state on error
          this.activeDiscountForUser = !this.activeDiscountForUser;
        });
    }
  }
}
</script>